import React, { useEffect, createContext, useState } from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.scss";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import Home from "./pages/Home";
import { message, Modal } from "antd";
import $axios from "./services/axios";
import PaymentStatus from "./pages/PaymentStatus";
import { EStatusTrip } from "./helpers/const";
import Tracking from "./pages/Tracking";

const App = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [token, setToken] = useState("");
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const decodeToken = async () => {
    // Lấy token từ URL
    // if (!localStorage.getItem("taxiIpassToken")) {
    try {
      const res = await $axios.$post("/api/v1/gsm/login", {
        Phone: "0900123456",
        FullName: "Nguyễn Văn A",
        VerifyToken: process.env.REACT_APP_VERIFY_TOKEN,
      });
      sessionStorage.setItem(
        "userInfo",
        JSON.stringify(res.data.data.userInfo)
      );
      setToken(res.data.data.token);
      localStorage.setItem("taxiIpassToken", res.data.data.token);
      history.replace({
        pathname: location.pathname,
      });
    } catch (error) {
      message.error(error?.message || "Xảy ra lỗi vui lòng thử lại !");
    }
    // }
  };

  useEffect(() => {
    if (location.pathname === "/taxi" && !loading) {
      fetchBookingInfo();
    }
  }, [location, loading]);

  const fetchBookingInfo = async () => {
    const orderCode = localStorage.getItem("taxiIpassOrderCode");
    if (!orderCode) return;
    setLoading(true);
    try {
      const res = await $axios.$get(
        `api/v1/gsm/transactions/details?orderCode=${orderCode}`
      );
      if (res?.data?.data?.data) {
        const resTrip = await $axios.get(
          `/api/v1/gsm/trip?tripId=${res.data.data.data.tripId}`
        );
        if (resTrip?.data?.data) {
          if (
            [
              EStatusTrip.ARRIVED,
              EStatusTrip.COMING,
              EStatusTrip.FINDING,
              EStatusTrip.JOURNEY,
            ].includes(resTrip?.data?.data.status)
          ) {
            message.success("Bạn có chuyến đi chưa hoàn thành!");
            history.push(`/tracking?orderCode=${orderCode}`);
          } else {
            localStorage.removeItem("taxiIpassOrderCode");
          }
          console.log(resTrip, "resTrip");
        }
      } else {
        localStorage.removeItem("taxiIpassOrderCode");
      }
    } catch (error) {
      localStorage.removeItem("taxiIpassOrderCode");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/taxi"} />
        <Route
          exact
          path={"/taxi"}
          render={(props) => <Home {...props} token={token} />}
        />
        <Route
          exact
          path={"/payment-status"}
          render={(props) => <PaymentStatus {...props} token={token} />}
        />
        <Route
          exact
          path={"/tracking"}
          render={(props) => <Tracking {...props} token={token} />}
        />
        <Redirect to={"/taxi"} />
      </Switch>
      {contextHolder}
    </>
  );
};
export default App;
